import { Injectable } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

@Injectable(
  {
    providedIn: 'root'
  }
)
export class FormService {

  constructor() { }

  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);

      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      }
      else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  validateAllFormFieldsArray(array: FormArray) {
    array.controls.forEach(control => {
      if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
    });
  }

  validateAllFormFieldsArrayAtIndex(array: FormArray, index: number) {
    const control = array.at(index);
    if (control instanceof FormGroup) {
      this.validateAllFormFields(control);
    }
  }

  passwordMatchValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      const password = control.get('password');
      const confirmPassword = control.get('confirmPassword');

      if (password && confirmPassword && password.value !== confirmPassword.value) {
        return { passwordMismatch: true };
      }
      return null;
    };
  }

  atLeastOneValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control || !('controls' in control)) return null;

      const group = control as any;
      const hasOne = Object.keys(group.controls).some(key => {
        const value = group.get(key)?.value;
        return value !== null && value !== undefined && value !== '';
      });

      return hasOne ? null : { atLeastOne: true };
    };
  }

  dateOfBirthValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value ? new Date(control.value) : null;
      if (!value) return null;

      const today = new Date();
      const minDate = new Date(today.getFullYear() - 120, today.getMonth(), today.getDate());

      if (value >= today) {
        return { futureDate: true };
      }

      if (value <= minDate) {
        return { invalidAge: true };
      }

      return null;
    };
  }

  cpfValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const cpf = (control.value || '').replace(/\D/g, '');

      if (!cpf) return null;
      if (cpf.length !== 11) return { cpfInvalid: true };

      if (/^(\d)\1{10}$/.test(cpf)) return { cpfInvalid: true };

      const calcCheckDigit = (base: string, factor: number) => {
        let total = 0;
        for (let i = 0; i < base.length; i++) {
          total += parseInt(base[i], 10) * factor--;
        }
        const rest = total % 11;
        return rest < 2 ? 0 : 11 - rest;
      };

      const digit1 = calcCheckDigit(cpf.substring(0, 9), 10);
      const digit2 = calcCheckDigit(cpf.substring(0, 10), 11);

      if (digit1 !== parseInt(cpf[9], 10) || digit2 !== parseInt(cpf[10], 10)) {
        return { cpfInvalid: true };
      }

      return null;
    };
  }

  adjustDateForInput(stringDate: string | undefined): string | null {
    if (!stringDate) return null;

    const newDate = new Date(stringDate).toISOString().substring(0, 10)

    return newDate;
  }

}
